
import clsx from "clsx";
import { Badge } from "../../ui/Badge";
import { Tooltip } from "../../shared/Tooltip";
import { InformationCircleIcon } from "@heroicons/react/20/solid";

export function PriorityIndicator({ lead }) {
  const tooltipId = `priority-tooltip-${lead?.id || Math.random()}`;

  return (
    <div className="flex items-center gap-2">
      <Badge
        variant="soft"
        style={{ color: lead?.PriorityColorCode }}
        className="text-xs font-medium"
      >
        {lead?.Priority}
      </Badge>
      {lead?.PriorityDescription && (
        <>
          <InformationCircleIcon
            className="size-4 text-gray-400 cursor-help hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 transition-colors"
            data-tooltip-id={tooltipId}
            data-tooltip-content={lead?.PriorityDescription}
          />
          <Tooltip
            id={tooltipId}
            place="top"
            effect="solid"
          />
        </>
      )}
    </div>
  );
}
